const navBar = {
  homeButton: 'nav-bar-home-button',
  insuredsButton: 'nav-bar-list-insureds-button',
  projectsButton: 'nav-bar-projects-button',
  reportsButton: 'nav-bar-reports-button',
  templatesButton: 'nav-bar-templates-button',
  adminSettingsButton: 'nav-bar-admin-button',
  zendeskHelpButton: 'nav-bar-zendesk-button'
};

const header = {
  toggleNavBarButton: 'header-toggle-nav-bar-button',
  userSettingsButton: 'header-user-settings-button',
  headerLogoutButton: 'header-logout-button',
  pinsLogoButton: 'header-logo-image'
};

const homePage = { selectDepartmentReportButton: 'home-select-department-report-button' };

const insuredsListPage = {
  searchInsuredsInput: 'insureds-search-insureds-input',
  filterInsuredsButton: 'insureds-filter-insureds-button',
  filterInsuredsStatusDropdown: 'insureds-filter-insured-status-dropdown',
  applyInsuredsFilterButton: 'insureds-apply-insureds-filter-button',
  clearInsuredsFilterButton: 'insureds-clear-insureds-filter-button',
  createNewInsuredButton: 'insureds-create-new-insured-button',
  downloadInsuredListExcelButton: 'insureds-download-excel-button',
  saveNewInsuredButton: 'insureds-save-new-insured-button',
  createInsuredForm: {
    companyNameInput: 'insureds-create-form-company-name-input',
    primaryContactEmailInput: 'insureds-create-form-primary-contact-email-input',
    secondaryContactEmailInput: 'insureds-create-form-secondary-contact-email-input',
    defaultInsuranceRequirementDropdown: 'insureds-create-form-default-insurance-requirement-dropdown',
    insuredIdInput: 'insureds-create-form-insured-id-input',
    businessTypeDropdown: 'insureds-create-form-business-type-dropdown',
    descriptionInput: 'insureds-create-form-description-input',
    addressInput: 'insureds-create-form-address-input',
    cityInput: 'insureds-create-form-city-input',
    stateInput: 'insureds-create-form-state-input',
    postalCodeInput: 'insureds-create-form-postal-code-input',
    countryInput: 'insureds-create-form-country-input',
    primaryPhoneInput: 'insureds-create-form-primary-phone-input',
    secondaryPhoneInput: 'insureds-create-form-secondary-phone-input'
  }
};

// [data-analytics-id=""]

const insuredProfilePage = {
  insuredDetailsModal: {
    insuredNameHeaderButton: 'insured-profile-open-details-modal-header',
    insuredInfoTab: 'insured-profile-details-modal-info-tab',
    insuredAddressTab: 'insured-profile-details-modal-address-tab',
    insuredContactTab: 'insured-profile-details-modal-contact-tab',
    insuredSaveInfoButton: 'insured-profile-details-modal-save-info-button',
    insuredSaveAddressButton: 'insured-profile-details-modal-save-address-button',
    insuredSaveContactButton: 'insured-profile-details-modal-save-contact-button'
  },
  recordsComponent: {
    archivedRecords: 'insured-profile-show-archived-records',
    selectRecordRow: 'insured-profile-records-select-record-row'
  },
  itemsComponent: {
    bulkSuggestApplyCodeButton: 'insured-profile-units-bulk-suggest-apply-code-button',
    bulkApplyCodeButton: 'insured-profile-units-bulk--apply-code-button',
    bulkSuggestClearCodeButton: 'insured-profile-units-bulk-suggest-clear-code-button',
    bulkClearCodeButton: 'insured-profile-units-bulk-clear-code-button',
    bulkWaiveCodeButton: 'insured-profile-units-bulk-waive-code-button',
    bulkUnwaiveCodeButton: 'insured-profile-units-bulk-unwaive-code-button',
    bulkApplyExceptionCodeButton: 'insured-profile-units-bulk-apply-exception-code-button',
    bulkClearExceptionCodeButton: 'insured-profile-units-bulk-clear-exception-code-button',
    bulkCodeConfirmationButton: 'insured-profile-units-bulk-code-confirmation-button',
    suggestApplyCode: 'insured-profile-units-suggest-apply-code',
    applyCode: 'insured-profile-units-apply-code',
    suggestClearCode: 'insured-profile-units-suggest-clear-code',
    clearCode: 'insured-profile-units-clear-code',
    waiveCode: 'insured-profile-units-waive-code',
    unwaiveCode: 'insured-profile-units-unwaive-code',
    applyExceptionCode: 'insured-profile-units-apply-exception-code',
    clearExceptionCode: 'insured-profile-units-clear-exception-code',
    searchUnitsComponentInput: 'insured-profile-units-search-units-component-input',
    filterPopoverButton: 'insureds-profile-units-filter-button',
    viewColumnSelectionPopoverButton: 'insured-profile-units-view-column-selection-popover'
  },
  policiesComponent: {
    openEmailAgentModalButton: 'insured-profile-policies-open-email-agent-modal-button',
    openEditPolicyTrayButton: 'insured-profile-policies-open-edit-policy-tray-button',
    openAddPolicyTrayButton: 'insured-profile-policies-open-add-policy-tray-button',
    openInsuranceCompanyAMBestRating: 'insured-profile-policies-open-insurance-company-ambest-rating',
    waiveRequirement: 'insured-profile-policies-waive-requirement',
    archivePolicy: 'insured-profile-policies-archive-policy',
    deletePolicy: 'insured-profile-policies-delete-policy',
    cancelPolicy: 'insured-profile-policies-cancel-policy',
    markPolicyCompliant: 'insured-profile-policies-mark-policy-compliant',
    markPolicyNotReceived: 'insured-profile-policies-mark-policy-not-received',
    markPolicyNonCompliant: 'insured-profile-policies-mark-policy-noncompliant',
    markPolicyPending: 'insured-profile-policies-mark-policy-pending',
    markPolicyRequired: 'insured-profile-policies-mark-policy-required',
    activatePolicy: 'insured-profile-policies-activate-policy',
    openArchivePolicyModalButton: 'insured-profile-policies-open-archive-policy-modal-button',
    openRemoveAgentModalButton: 'insured-profile-policies-open-remove-agent-modal-button',
    emailAgentModal: {
      previewEmailButton: 'insured-profile-policies-preview-agent-email',
      sendEmailButton: 'insured-profile-policies-send-agent-email'
    },
    removeAgentModal: {
      confirmButton: 'insured-profile-policies-remove-agent-modal-confirm-button',
      cancelButton: 'insured-profile-policies-remove-agent-modal-cancel-button'
    },
    gearSettingsIcon: {
      openEmailHistoryTray: 'insured-profile-policies-open-email-history-tray',
      openNotificationsTray: 'insured-profile-policies-open-notifications-tray',
      openSendEmail: 'insured-profile-policies-open-send-email',
      openRequirementsEditor: 'insured-profile-policies-open-requirements-editor',
      openProjectRequirements: 'insured-profile-policies-view-project-requirements',
      openLinkToCustomDate: 'insured-profile-policies-open-link-to-custom-date',
      openCreateCertificateTray: 'insured-profile-policies-open-create-certificate-tray',
      openCloneInsuranceModal: 'insured-profile-policies-open-clone-insurance-modal',
      openPrintPageModal: 'insured-profile-policies-open-print-page-modal',
      openDeleteRequirementsModal: 'insured-profile-policies-open-delete-requirements-modal'
    },
    emailHistoryTray: {
      refreshEmailHistoryButton: 'insured-profile-policies-refresh-email-history-button',
      sortEmailHistory: 'insured-profile-policies-sort-email-history',
      sortEmailHistoryByJob: 'insured-profile-policies-sort-email-history-by-job',
      openViewEmailButton: 'insured-profile-policies-open-view-email-button',
      resendEmailButton: 'insured-profile-policies-resend-email-button',
      printEmailButton: 'insured-profile-policies-print-email-button'
    }
  },
  documentsComponent: {
    uploadDocumentButton: 'insured-profile-documents-upload-document-button',
    openLinkDocumentToPolicyModal: 'insured-profile-documents-open-link-document-to-policy-document',
    openEditNameModal: 'insured-profile-documents-open-edit-name-modal',
    archiveDocument: 'insured-profile-documents-archive-document',
    selectPolicyToLink: 'insured-profile-documents-select-policy-to-link',
    customExpirationDateCalendar: 'insured-profile-documents-set-custom-expiration-date',
    updateDocumentNameButton: 'insured-profile-documents-update-document-name-button',
    activateDocument: 'insured-profile-documents-activate-document',
    deleteDocument: 'insured-profile-documents-delete-document',
    markDocumentRequired: 'insured-profile-documents-require-document',
    markDocumentCompliant: 'insured-profile-documents-mark-document-compliant',
    markDocumentNonCompliant: 'insured-profile-documents-mark-document-noncompliant',
    markDocumentPending: 'insured-profile-documents-mark-document-pending',
    waiveDocumentRequirement: 'insured-profile-documents-waive-document-requirement',
    uploadElsewhereDocumentRequirement: 'insured-profile-documents-upload_elsewhere-document-requirement',
    openArchivedDocumentsModal: 'insured-profile-documents-open-archived-documents-modal',
    downloadDocument: 'insured-profile-documents-download-document',
    addCustomExpiration: 'insured-profile-documents-add-custom-expiration',
    editCustomExpiration: 'insured-profile-documents-edit-custom-expiration',
    deleteCustomExpiration: 'insured-profile-documents-delete-custom-expiration'
  },
  attachmentsComponent: {
    uploadAttachmentButton: 'insured-profile-attachments-upload-attachment-button',
    archiveAttachment: 'insured-profile-attachments-archive-attachment',
    activateAttachment: 'insured-profile-attachments-activate-attachment',
    deleteAttachment: 'insured-profile-attachments-delete-attachment',
    openArchivedAttachmentsModal: 'insured-profile-attachments-open-archived-attachments-modal',
    downloadAttachment: 'insured-profile-attachments-download-attachment'
  },
  activityLog: {
    openFilterModal: 'insured-profile-activity-log-open-filter-modal',
    refreshActivityLogButton: 'insured-profile-activity-log-refresh-activity-log-button',
    allActivityFilterButton: 'insured-profile-activity-log-all-activity-filter-button',
    actionsFilterButton: 'insured-profile-activity-log-actions-filter-button',
    commentsFilterButton: 'insured-profile-activity-log-comments-filter-button',
    searchActivityLogInput: 'insured-profile-activity-log-search-activity-log-input',
    createCommentButton: 'insured-profile-activity-log-create-comment-button',
    openLinkModal: 'insured-profile-activity-log-open-link-modal',
    applyLinkButton: 'insured-profile-activity-log-apply-link-button',
    postCommentButton: 'insured-profile-activity-log-post-comment-button',
    trashCommentButton: 'insured-profile-activity-log-trash-comment-button',
    createSubComment: 'insured-profile-activity-log-create-sub-comment'
  }
};

const projectsListPage = {
  filterByStatusDropdown: 'projects-filter-by-status-dropdown',
  searchProjectsInput: 'projects-search-projects-input',
  filterProjectsPopoverButton: 'projects-filter-projects-popover-button',
  createNewProjectButton: 'projects-create-new-project-button',
  downloadProjectsExcelButton: 'projects-download-projects-excel-button',
  selectJobRow: 'projects-job-row',
  createProjectForm: {
    nameInput: 'projects-name-input',
    numberInput: 'projects-number-input',
    descriptionInput: 'projects-description-input',
    departmentDropdown: 'projects-department-dropdown',
    startDateCalender: 'projects-start-date-calendar',
    endDateCalendar: 'projects-end-date-calendar',
    projectOwnerDropdown: 'projects-owner-dropdown',
    requirementTemplateDropdown: 'projects-requirement-template-dropdown',
    saveProjectButton: 'projects-save-project-button'
  }
};

const projectDetailsPage = {
  backToProjectListButton: 'project-details-back-to-project-list-button',
  editButton: 'project-details-edit-project-button',
  saveButton: 'project-details-save-project-button',
  updateStatusDropdown: 'project-details-update-status-dropdown',
  editProjectForm: {
    name: 'project-details-name-input',
    number: 'project-details-number-input',
    description: 'project-details-description-input',
    startDate: 'project-details-start-date-input',
    endDate: 'project-details-end-date-input',
    ownerDropdown: 'project-details-owner-dropdown',
    departmentDropdown: 'project-details-department-dropdown',
    requirementTemplateDropdown: 'project-details-requirement-template-dropdown',
    attachmentsButton: 'project-details-attachments-button'
  },
  searchInsuranceRequirements: 'project-details-search-insurance-requirements-input',
  filterByInsuranceRequirementStatus: 'project-details-filter-by-insurance-requirements-status',
  addInsuredToProjectButton: 'project-details-add-insured-to-project-button',
  downloadRecordsExcelButton: 'project-details-download-records-excel-button',
  addInsuredToListTab: 'project-details-add-insured-to-list-tab',
  searchInsuredsTab: 'project-details-search-insureds-tab',
  applyProjectRequirementsSwitch: 'project-details-apply-project-requirements-switch',
  addInsuredToListButton: 'project-details-add-insured-to-list-button'
};

const reportsPage = {
  expiredPresetButton: 'reports-expired-preset-button',
  nonCompliantPresetButton: 'reports-non-compliant-preset-button',
  pendingReviewPresetButton: 'reports-pending-preset-button',
  delinquentPresetButton: 'reports-delinquent-preset-button',
  insuredsPresetButton: 'reports-insureds-preset-button',
  sendEmailButton: 'reports-send-email-button',
  exportToExcelButton: 'reports-export-to-excel-button',
  insuredProfileNameLink: 'reports-insured-profile-name-link',
  insuredExternalIdLink: 'reports-insured-external-id-link',
  insuredParentIdLink: 'reports-insured-parent-id-link',
  openProjectLink: 'reports-open-project-link',
  searchReportsInput: 'reports-search-reports-input',
  reportsFilterPopoverButton: 'reports-filter-popover-button',
  openColumnSelectionPopover: 'reports-open-column-selection-popover',
  excelReportRecipients: 'reports-excel-report-email-recipients',
  excelReportCcRecipients: 'reports-excel-report-email-cc-recipients',
  confirmExportReportButton: 'reports-confirm-export-report-button',
  downloadDocumentsButton: 'reports-download-documents-button',
  downloadDocumentsButtonConfirm: 'reports-confirm-download-documents-button'
};

const emailEditorPage = {
  confirmSendEmailModalButton: 'email-editor-confirm-send-email-modal-button',
  sendEmailButton: 'email-editor-send-email-button',
  previewEmailButton: 'email-editor-preview-email-button',
  templateSelectorPopoverButton: 'email-editor-open-template-selector-popover',
  tokenSelectorPopoverButton: 'email-editor-template-selector-popover'
};

const templatesPage = {
  createTemplateModal: { selectTemplateModal: { selectTemplateRow: 'templates-template-row' } },
  templatesDropdown: 'active-templates-dropdown'
};

const adminSettingsPage = {
  users: {
    usersTab: 'admin-settings-users-tab',
    searchUsersInput: 'admin-settings-search-users-input',
    filterByStatusDropdown: 'admin-settings-users-filter-by-status-dropdown',
    addNewUserButton: 'admin-settings-add-new-user-button',
    editUserButton: 'admin-settings-edit-user-button',
    deleteUserButton: 'admin-settings-delete-user-button',
    deactivateUserButton: 'admin-settings-deactivate-user-button',
    reactivateUserButton: 'admin-settings-reactivate-user-button',
    createUserForm: {
      firstName: 'admin-settings-create-user-first-name-input',
      lastName: 'admin-settings-create-user-last-name-input',
      email: 'admin-settings-create-user-email-input',
      phone: 'admin-settings-create-user-phone-input',
      externalId: 'admin-settings-create-user-external-id-input',
      supervisorDropdown: 'admin-settings-create-user-supervisor-dropdown',
      resendInviteButton: 'admin-settings-resend-user-invite-button',
      inviteSaveUser: 'admin-settings-invite-save-user-button'
    }
  },
  departments: {
    departmentsTab: 'admin-settings-departments-tab',
    searchDepartmentsInput: 'admin-settings-search-departments-input',
    filterByStatusDropdown: 'admin-settings-departments-filter-by-status-dropdown',
    addNewDepartmentButton: 'admin-settings-add-new-department-button',
    editDepartmentButton: 'admin-settings-edit-department-button',
    deleteDepartmentButton: 'admin-settings-delete-department-button',
    departmentRowOptionsButton: 'admin-settings-department-row-options-button',
    confirmDeleteDepartmentButton: 'admin-settings-confirm-delete-department-button',
    archiveDepartmentButton: 'admin-settings-deactivate-department-button',
    reactivateDepartmentButton: 'admin-settings-reactivate-department-button',
    createDepartmentForm: {
      name: 'admin-settings-create-department-name-input',
      departmentId: 'admin-settings-create-department-department-id-input',
      radioSameAddress: 'admin-settings-create-department-radio-same-address',
      radioDifferentAddress: 'admin-settings-create-department-radio-different-address',
      address1: 'admin-settings-create-department-address-1-input',
      address2: 'admin-settings-create-department-address-2-input',
      city: 'admin-settings-create-department-city-input',
      state: 'admin-settings-create-department-state-input',
      zip: 'admin-settings-create-department-zip-input',
      saveDepartmentButton: 'admin-settings-save-department-button'
    }
  },
  compliance: { complianceTab: 'admin-settings-compliance-tab' }
};

const userSettings = {
  profile: {
    profileTab: 'user-settings-profile-tab',
    saveUserInfoButton: 'user-settings-save-user-info-button',
    changePasswordButton: 'user-settings-change-password-button'
  },
  emailSettings: {
    emailSettingsTab: 'user-settings-email-settings-tab',
    replyToSwitch: 'user-settings-reply-to-switch',
    automaticInsuranceApprovalEmailSwitch: 'user-settings-automatic-insurance-approval-email-switch',
    saveSettingsButton: 'user-settings-save-settings-button'
  }
};

const emailAutomations = {
  emailAutomationsTabs: 'admin-settings-email-automations-tab',
  emailAutomationSettingsHeader: 'admin-settings-email-automation-settings-header'
};

const createUniqueSelector = (identifier, selector) => `${identifier}-${selector}`;

export const analyticsIds = {
  navBar,
  header,
  homePage,
  insuredsListPage,
  insuredProfilePage,
  projectsListPage,
  projectDetailsPage,
  reportsPage,
  emailEditorPage,
  templatesPage,
  adminSettingsPage,
  userSettings,
  createUniqueSelector,
  emailAutomations
};
